import { IssuanceDocumentType, IssuanceDocumentSubFolderType } from './IssuanceDocument';

export enum PagePath {
  Root = '/',

  // ログイン
  Login = '/Login/',
  // 代行ログイン（管理画面からの遷移専用の受け口）
  AgencyLogin = '/AgencyLogin/',
  // SMS認証
  SendSMS = '/SendSMS/',
  //ActivationCode確認
  ActivationCode = '/ActivationCode/',
  // PW再発行
  ReissuePassword = '/ReissuePassword/',
  // 法人口座開設事前質問
  AccountOpen = '/AccountOpen/',
  // 法人口座開設本登録回答
  AccountOpenProfileDetails = '/AccountOpenProfileDetails/',
  // 個人口座開設事前質問
  PersonalAccountOpen = '/PersonalAccountOpen/',
  // 個人口座開設本登録回答
  PersonalAccountOpenProfileDetails = '/PersonalAccountOpenProfileDetails/',

  // ホーム
  Home = '/Home/',

  // 案件一覧
  ProgramList = '/ProgramList/',
  //LeaseFundProgramList = '/LeaseFundProgramList/',
  //DomesticRealEstateItExplanationProgramList = '/DomesticRealEstateItExplanationProgramList/',
  // 案件詳細
  LeaseFundSymbolDetail = '/LeaseFundSymbolDetail/',
  DomesticRealEstateItExplanationSymbolDetail = '/DomesticRealEstateItExplanationSymbolDetail/',
  DomesticRealEstateSymbolDetail = '/DomesticRealEstateSymbolDetail/',
  OverseasRealEstateSymbolDetail = '/OverseasRealEstateSymbolDetail/',

  // 出資案件
  Position = '/Position/',
  // 申込履歴
  RequestHistory = '/RequestHistory/',

  // 交付書面
  IssuanceDocument = '/IssuanceDocument/',

  // ご契約手続き
  LeaseFundContractProcedure = '/ContractProcedure/',
  OverseasRealEstateContractProcedure = '/OverseasRealEstateContractProcedure/',

  // 利用者登録
  SubUser = '/SubUser/',
  // 利用者追加
  SubUserAdd = '/SubUserAdd/',

  // 適合性チェック回答入力
  CompatibilityCheck = '/CompatibilityCheck/',

  // 適合性チェック結果確認
  ConfirmCompatibilityCheck = '/ConfirmCompatibilityCheck/',

  // お知らせ
  Notice = '/Notice/',
  //お問い合わせ
  Contact = '/Contact/',
  // お知らせ詳細
  NoticeDetail = '/NoticeDetail/',

  // 登録内容の確認・変更
  AccountInfo = '/AccountInfo/',
  // パスワード変更
  ChangePassword = '/ChangePassword/',
  //FAQ
  Faq = '/Faq/',
  FaqLink = '/FaqLink/',
}

class InnerPagePathFactory {
  leaseFundSymbolDetail = (symbol: string) => {
    return `${PagePath.LeaseFundSymbolDetail}${symbol}/`;
  };
  domesticRealEstateItExplanationSymbolDetail = (symbol: string) => {
    return `${PagePath.DomesticRealEstateItExplanationSymbolDetail}${symbol}/`;
  };
  overseasRealEstateSymbolDetail = (symbol: string) => {
    return `${PagePath.OverseasRealEstateSymbolDetail}${symbol}/`;
  };
  issuanceDocumentFromFolderId = (folderId: string) => {
    return `${PagePath.IssuanceDocument}?id=${folderId}`;
  };
  issuanceDocumentFromDocumentType = (documentType: IssuanceDocumentType | string) => {
    return `${PagePath.IssuanceDocument}?id=${documentType}`;
  };
  issuanceDocumentFinancialReport = (documentType: IssuanceDocumentType, symbolName: string) => {
    return `${PagePath.IssuanceDocument}?id=${documentType}${IssuanceDocumentSubFolderType.FinancialReport}&name=${symbolName}`;
  };
  issuanceDocumentContract = (documentType: IssuanceDocumentType, symbol: string) => {
    return `${PagePath.IssuanceDocument}?id=${documentType}${IssuanceDocumentSubFolderType.Contract}${symbol}`;
  };
  faqSymbolProductType = (id: number) => {
    return `${PagePath.Faq}${id}`;
  };
  faqLinkSymbolProductType = (id: number) => {
    return `${PagePath.FaqLink}${id}`;
  }
}

export const PagePathFactory = new InnerPagePathFactory();
